import { Toaster } from "react-hot-toast";
import MyRouter from "routers/index";
import { AuthProvider } from "context/AuthContext";
import { ProductProvider } from "context/ProductContext";
import { Provider } from "react-redux";
import { store } from "app/store";
import { PersistGate } from "redux-persist/es/integration/react";
import { persistor } from "app/store";
import { Profiler } from "react";
import onRenderCallback from "utils/isRenderCallback";
//
const isDev = process.env.NODE_ENV === "development";

function App() {
  return (
    <>
      {isDev ? (
        <Profiler onRender={onRenderCallback} id={"App"}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <AuthProvider>
                <div>
                  <Toaster />
                </div>
                <ProductProvider>
                  <MyRouter />
                </ProductProvider>
              </AuthProvider>
            </PersistGate>
          </Provider>
        </Profiler>
      ) : (
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AuthProvider>
              <div>
                <Toaster />
              </div>
              <ProductProvider>
                <MyRouter />
              </ProductProvider>
            </AuthProvider>
          </PersistGate>
        </Provider>
      )}
    </>
  );
}

export default App;
